import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import CustomSkeleton from "../components/CustomSkeleton/CustomSkeleton";
import dynamic from "next/dynamic";
import LandingLayout from "../components/_Landings/layout";
import { useEffect } from "react";
var DynamicLanding = dynamic(function() {
    return import("../components/_Landings/B2C/ResidentialLanding");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../components/_Landings/B2C/ResidentialLanding")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var ResidentialPage = function() {
    useEffect(function() {
        window.scrollTo(0, 0);
    }, []);
    var headerProps = {
        title: "Ahorra tus facturas con Fiva | Compara las mejores tarifas de luz y gas para hogares",
        keywords: "Comparador de tarifas para particulares, Comparador de luz y gas para hogares, Tarifas el\xe9ctricas para residencias, \n    Proveedores de electricidad para particulares, Tarifas de gas para el hogar, Consultor\xeda energ\xe9tica residencial, \n    Optimizaci\xf3n de consumo energ\xe9tico en hogares, Soluciones de energ\xeda renovable para residencias, \n    Eficiencia energ\xe9tica para el hogar, Asesor\xeda en tarifas el\xe9ctricas para particulares, Mejores tarifas de luz para residencias, \n    Comparativa de precios de gas y electricidad para hogares, Servicios de asesoramiento energ\xe9tico para residencias, \n    Ofertas de electricidad y gas para el hogar, Ahorro energ\xe9tico en el sector residencial",
        content: "Descubre las mejores tarifas de luz y gas para tu hogar y contrata de forma r\xe1pida y sencilla online. Gesti\xf3n f\xe1cil y sin complicaciones."
    };
    return /*#__PURE__*/ _jsxs(LandingLayout, {
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicLanding, {})
        ]
    });
};
export default ResidentialPage;
